import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
import { useCallback, useEffect, useState } from 'react';

// @ts-expect-error Could not find a declaration file for module 'feedback-loader/useFeedbackLoader'.
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import { getFormattedExerciseLocation } from '../../utils/ContentUtils';
const PRACTICAL_EXERCISE_SURVEY_ID_PROD = 1282;
export const useNavigateToExercise = ({
  exerciseLocation,
  onClick
}) => {
  const [navigationLoading, setNavigationLoading] = useState(false);
  const navigateToExercise = useCallback(async simulationPortalId => {
    try {
      setNavigationLoading(true);
      // Handle onClick callback first if provided
      if (onClick) {
        await onClick(simulationPortalId);
      }
      const portalId = PortalIdParser.getPortalIdFromPath();
      window.open(getFormattedExerciseLocation(exerciseLocation, simulationPortalId || portalId), '_self');
    } catch (error) {
      Raven.captureException(error);
    } finally {
      setNavigationLoading(false);
    }
  }, [exerciseLocation, onClick]);
  return {
    navigateToExercise,
    loading: navigationLoading
  };
};
export const useLoadPracticalExerciseSurvey = ({
  skip
}) => {
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  useEffect(() => {
    if (skip || !enviro.isProd() || !clientLoaded) {
      return;
    }
    loadSurvey(PRACTICAL_EXERCISE_SURVEY_ID_PROD, 'CSAT');
  }, [skip, clientLoaded, loadSurvey]);
};